import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import ChangePassword from "../views/distribute/ChangePassword.vue";
import Distribute from "../views/distribute/Distribute.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: Home
    },
    {
        path: "/login",
        component: Login
    },
    {
        path: "/distribute/changePassword",
        component: ChangePassword
    },
    {
        path: "/distribute/distribute",
        component: Distribute
    }
];

const router = new VueRouter({
    routes
});

export default router;
